import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const BudgetFilters = ({ filters, onChange }) => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative">
        <Icon name="Calendar" size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <select
          value={filters?.period}
          onChange={(e) => onChange({ ...filters, period: e?.target?.value })}
          className="pl-8 pr-3 py-2 text-sm border border-border rounded-lg bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-accent"
        >
          <option value="all">{t('allTime')}</option>
          <option value="month">{t('thisMonth')}</option>
          <option value="quarter">{t('thisQuarter')}</option>
          <option value="year">{t('thisYear')}</option>
        </select>
      </div>
      <div className="relative">
        <Icon name="Filter" size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <select
          value={filters?.category}
          onChange={(e) => onChange({ ...filters, category: e?.target?.value })}
          className="pl-8 pr-3 py-2 text-sm border border-border rounded-lg bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-accent"
        >
          <option value="all">{t('allCategories')}</option>
          <option value="materials">{t('materials')}</option>
          <option value="labour">{t('labour')}</option>
          <option value="equipment">{t('equipment')}</option>
          <option value="subcontractors">{t('subcontractors')}</option>
        </select>
      </div>
    </div>
  );
};

export default BudgetFilters;
